import { render } from "./StockStatusListPage.vue?vue&type=template&id=64a26711&ts=true"
import script from "./StockStatusListPage.vue?vue&type=script&lang=ts"
export * from "./StockStatusListPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__